import * as React from 'react';
import {
  Card, CardContent, CardMedia,
  Grid, List, ListItem, ListItemIcon, ListItemText,
  Typography
} from "@mui/material";
import {Stack} from "@mui/system";
import Chef from "../../images/bloodychef-crop.jpeg";
import {WheatIcon} from "../icon/WheatIcon";

function About(props) {
  return (
    <Grid container padding={2} paddingLeft={{xs: '5%', sm: '10%', md: '15%', lg: '20%'}} paddingRight={{xs: '5%', sm: '10%', md: '15%', lg: '20%'}}
          justifyContent={'center'} alignItems={'center'}>
      <Stack spacing={2}>
        <Typography  align={'center'} variant={'h5'}>About the Bakery</Typography>
        <Card variant={'elevation'} elevation={5} width="85%">
          <CardMedia sx={{marginLeft: '25%', marginTop: 2, maxWidth: '50%'}} component="img" image={Chef}/>
          <CardContent>
            <Typography align={'center'} fontSize={14}>
              I found I am dangerous around knives,
              <br/>so I took up baking!
            </Typography>
            <Typography align={'center'} fontSize={14}>
              <br/>
              Actually, I'm a retired software engineer who loves baking and eating sourdough...
            </Typography>
            <List>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  I started a "nano" Cottage business in 2025
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  All my stuff is sourdough-based; most recipes use a 24+ hour fermentation process
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  I try to use organic flour and grain; I mill a lot of grain into flour myself
                </ListItemText>
              </ListItem>
              <ListItem dense={true}>
                <ListItemIcon>
                  <WheatIcon />
                </ListItemIcon>
                <ListItemText sx={{marginLeft: -2}}>
                  In my pricing, I try to cover some material cost but make it as affordable as I can
                </ListItemText>
              </ListItem>
            </List>
            <Typography align={'center'} fontWeight={500} fontSize={14}>
              I hope you enjoy my breads and I welcome your feedback!
            </Typography>
          </CardContent>
        </Card>
      </Stack>
    </Grid>
  )
}

export { About }